import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import { motion } from "framer-motion";
import WhatWeDo from "../components/WhatWeDo";
import Plans from "../components/Plans";
import Footer from "../components/Footer";
import Avaliacoes from "../components/Avaliacoes";
import { Button } from "@mui/material";
import ModalHome from "../components/ModalHome";
import Seo from "../../components/Seo";

const Planos = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [openModalHome, setOpenModalHome] = useState(false);

    useEffect(() => {
        const isFbqAvailable = typeof window.fbq !== 'undefined';

        if (isFbqAvailable) {
            window.fbq('track', 'ViewContent', {
                value: 147,
                currency: 'BRL',
            });
        }

        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    useEffect(() => {
        const STORAGE_KEY = "ultimaVisitaSitePlanos";
        const RECORRENCIA_KEY = "recorrenciaSitePlanos";

        const now = Date.now();

        // Tempo mínimo para considerar uma nova visita
        // Ex: 2 dias fora do site
        const TEMPO_NOVA_VISITA = 1000 * 60 * 60 * 24 * 2;

        const ultimaVisita = Number(localStorage.getItem(STORAGE_KEY) || 0);
        const recorrenciaAtual = Number(localStorage.getItem(RECORRENCIA_KEY) || 0);

        const tempoDesdeUltimaVisita = now - ultimaVisita;

        // Só considera nova recorrência se realmente saiu do site
        if (tempoDesdeUltimaVisita > TEMPO_NOVA_VISITA) {
            const novaRecorrencia = recorrenciaAtual + 1;

            localStorage.setItem(RECORRENCIA_KEY, novaRecorrencia);

            let eventName = null;

            if (novaRecorrencia === 1) {
                eventName = "RecorrenciaSitePlanos2x";
            } else if (novaRecorrencia === 2) {
                eventName = "RecorrenciaSitePlanos3x";
            } else if (novaRecorrencia === 3) {
                eventName = "RecorrenciaSitePlanos4x";
            } else if (novaRecorrencia >= 4) {
                eventName = "RecorrenciaSitePlanos5x";
            }

            if (eventName && typeof window.fbq !== "undefined") {
                console.log(`Rastreando evento ${eventName}`);

                window.fbq("trackCustom", eventName, {
                    recorrencia: novaRecorrencia,
                });
            }
        }

        // Atualiza timestamp da última atividade
        const updateLastVisit = () => {
            localStorage.setItem(STORAGE_KEY, Date.now());
        };

        updateLastVisit();

        window.addEventListener("beforeunload", updateLastVisit);

        return () => {
            window.removeEventListener("beforeunload", updateLastVisit);
        };
    }, []);


    const listPlans = [
        {
            title: "Plano Starter",
            subTitle: "Aqui sua jornada digital começa com o pé direito! Coloque sua saúde financeira em dia e dê os primeiros passos com o plano Starter.",
            description: "Por apenas R$147 por mês, você tem:",
            advantages: [
                "Elaboração e entrega de obrigações fiscais para até 1 pessoa física (sócio);",
                "Constituição e entrega de obrigações fiscais para até 1 pessoa jurídica MEI (faturamento de até 81.000,00/ano);",
                "Atendimento personalizado em horário comercial;",
                "Emissor fácil - até 3 notas fiscais por mês."
            ],
            finalText: <b>Assine agora e leve sua rotina digital para o próximo nível com a ContBlack!</b>,
            img: "/assets/starter.jpg"
        },
        {
            title: "Plano Básico",
            subTitle: "Dê um upgrade na sua gestão digital! O plano Básico coloca mais organização e controle na sua rotina financeira.",
            description: "Por apenas R$327 por mês, você tem:",
            advantages: [
                "Elaboração e entrega de obrigações fiscais para até 1 pessoa física;",
                "Constituição e entrega de obrigações fiscais para até 1 pessoa jurídica MEI ou Simples Nacional (faturamento de até 30.000,00/mês);",
                "Atendimento personalizado em horário comercial;",
                "Folha de pagamento de até 1 colaboradores;",
                "Elaboração e entrega de obrigações fiscais para 2 pessoas físicas;",
                "Emissor fácil - até 50 notas fiscais por mês."

            ],
            finalText: <b>Assine já e comece a profissionalizar seu trabalho digital com a ContBlack!</b>,
            img: "/assets/basico.jpg"
        },
        {
            title: "Plano Avançado",
            subTitle: "Eleve sua performance digital! O plano Avançado é feito para quem quer mais controle e suporte estratégico no dia a dia.",
            description: "Por apenas R$ 657 por mês, você tem:",
            advantages: [
                "Elaboração e entrega de obrigações fiscais para até 1 pessoa física;",
                "Constituição e entrega de obrigações fiscais para até 1 pessoa jurídica MEI (faturamento de até 81.000,00/ano);",
                "Atendimento personalizado em horário comercial;",
                "Folha de pagamento de até 6 colaboradores;",
                "Elaboração e entrega de obrigações fiscais para 2 pessoas físicas;",
                "Constituição e entrega de obrigações fiscais para até 1 pessoa jurídica no regime SIMPLES NACIONAL;",
                "Grupo Exclusivo no WhatsApp;",
                "Emissor fácil - ilimitado;",
                "Emissão dedicada pela equipe Contblack - Até 50 notas fiscais/mês;",
                "Planejamento patrimonial com 20% de desconto."

            ],
            finalText: <b>Assine já e comece a profissionalizar seu trabalho digital com a ContBlack!</b>,
            img: "/assets/avancado.jpg"
        },
        {
            title: "Plano Plus+",
            subTitle: "Para quem quer dominar o universo digital: o plano Plus+ oferece suporte completo e alto nível de gestão para sua jornada profissional.",
            description: "Por apenas R$1.317 por mês, você tem:",
            advantages: [
                "Elaboração e entrega de obrigações fiscais para até 1 pessoa física;",
                "Constituição e entrega de obrigações fiscais para até 1 pessoa jurídica MEI (faturamento de até R$81.000/ano);",
                "Atendimento personalizado em horário comercial;",
                "Elaboração e entrega de obrigações fiscais para 2 pessoas físicas;",
                "Constituição e entrega de obrigações fiscais para até 1 pessoa jurídica no regime SIMPLES NACIONAL;",
                "Grupo Exclusivo no WhatsApp;",
                "Folha de pagamento de até 10 colaboradores;",
                "1 consultoria de até 4h por mês com emissão de parecer;",
                "Emissor fácil - ilimitado;",
                "Emissão dedicada pela equipe Contblack - Até 50 notas fiscais/mês;",
                "Planejamento patrimonial com 50% de desconto."
            ],
            finalText: <b>Assine já e transforme sua rotina digital com a ContBlack, com suporte total para crescer com segurança e liberdade!</b>,
            img: "/assets/plus.jpg"
        }
    ];


    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    console.log("Usuário chegou na seção!");

                    sendEventToMeta();

                    // para executar apenas uma vez
                    observer.disconnect();
                }
            },
            {
                threshold: 0.5 // 50% da seção visível
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const sendEventToMeta = () => {
        const isFbqAvailable = typeof window.fbq !== 'undefined';
        if (isFbqAvailable) {
            console.log('Rastreando evento ScrollProfundoPlanos no Facebook Pixel');
            window.fbq('trackCustom', 'ScrollProfundoPlanos', {
                content_name: 'PlanosPage'
            });
        }
    };


    return (
        <>

            <Seo
                title="Planos de Contabilidade | Contblack"
                description="Planos a partir de R$147,00 por mês. Conheça nossos planos de contabilidade digital!"
            />
            <Header active="planos" />


            <div style={{
                marginTop: "80px",
                width: "100%",
                padding: "40px 20px",
                background: "linear-gradient(135deg, #233344, #15273a)",
            }}>
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    style={{
                        width: "90%",
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        color: "#fff"
                    }}
                >
                    <span style={{
                        padding: "8px 18px",
                        background: "rgba(255,255,255,0.1)",
                        borderRadius: "999px",
                        fontSize: "0.9rem",
                        marginBottom: "20px"
                    }}>
                        Creator Economy
                    </span>

                    <h2 style={{
                        fontSize: "clamp(2rem, 3vw, 3rem)",
                        marginBottom: "20px",
                        maxWidth: "850px",
                        color: "#1EFF86"
                    }}>
                        Criar conteúdo já é difícil. <br />
                        Cuidar da burocracia sozinho torna tudo pior!
                    </h2>

                    <p style={{
                        fontSize: "1.1rem",
                        lineHeight: "1.8",
                        maxWidth: "850px",
                        color: "#d1d1d1"
                    }}>
                        Muitos <span style={{ color: "#fff", fontWeight: "700" }}>creators</span> acabam pagando
                        <span style={{ color: "#fff", fontWeight: "700" }}> impostos errados</span>, misturando
                        <span style={{ color: "#fff", fontWeight: "700" }}> finanças pessoais</span>
                        com profissionais e perdendo
                        <span style={{ color: "#fff", fontWeight: "700" }}> oportunidades</span> por falta de
                        <span style={{ color: "#fff", fontWeight: "700" }}> organização</span>.
                        O <span style={{ color: "#fff", fontWeight: "700" }}>mercado digital</span> cresce rápido.
                        Sua <span style={{ color: "#fff", fontWeight: "700" }}>contabilidade</span> precisa ser
                        <span style={{ color: "#fff", fontWeight: "700" }}> especializada</span> para acompanhar seu ritmo.
                    </p>

                    <div style={{
                        marginTop: "50px",
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                        gap: "20px"
                    }}>
                        {[
                            "Recebimentos Internacionais",
                            "Monetização e Plataformas",
                            "Impostos e Regularização",
                            "Economia de Impostos",
                        ].map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                                style={{
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    padding: "25px",
                                    borderRadius: "24px",
                                    backdropFilter: "blur(10px)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <p style={{
                                    fontSize: "1rem",
                                    margin: 0,
                                    color: "#1EFF86",
                                    fontWeight: "600"
                                }}>
                                    {item}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>

            <div style={{ width: "100%", padding: "20px", background: "linear-gradient(35deg, #1EFF86 0%, #1b3a5d 100%)" }} >
                <div style={{
                    width: "80%",
                    maxWidth: "1200px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    margin: "30px auto"
                }}>
                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <img src="/assets/planos.jpg" alt="Descrição" style={{ width: "100%", height: "auto", borderRadius: "46px 0 46px 0" }} />
                    </motion.div>

                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <h2 style={{ fontSize: "2rem", marginBottom: "10px", color: "#f1f1f1" }}>Planos feitos para o seu universo digital</h2>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.6", color: "#f1f1f1" }}>
                            Oferecemos <b>soluções contábeis completas e seguras</b> para quem vive da criação de conteúdo online.
                            Deixe a parte fiscal conosco e dedique-se ao que importa: <b>expandir sua presença, engajar seu público e crescer no mercado digital.</b>
                        </p>
                    </motion.div>
                </div>
            </div>

            <div style={{
                marginTop: "120px",
                width: "100%",
                padding: "20px"
            }}>
                <div style={{
                    width: "90%",
                    maxWidth: "1200px",
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                    gap: "30px",
                    alignItems: "center"
                }}>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                        style={{
                            position: "relative"
                        }}
                    >
                        <img
                            src="/assets/creator-growth.jpg"
                            alt="Creator organizado"
                            style={{
                                width: "100%",
                                borderRadius: "46px 0 46px 0",
                                objectFit: "cover"
                            }}
                        />

                        <div style={{
                            position: "absolute",
                            bottom: "20px",
                            left: "20px",
                            background: "#fff",
                            padding: "16px 20px",
                            borderRadius: "20px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                        }}>
                            <p style={{
                                margin: 0,
                                fontWeight: "700",
                                fontSize: "1rem"
                            }}>
                                Mais controle. Mais crescimento.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        // initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <span style={{
                            color: "#777",
                            fontWeight: "600",
                            letterSpacing: "1px"
                        }}>
                            BENEFÍCIOS CONTBLACK
                        </span>

                        <h1 style={{
                            fontSize: "clamp(2rem, 4vw, 3.2rem)",
                            marginTop: "15px",
                            marginBottom: "20px"
                        }}>
                            A contabilidade que acompanha o seu crescimento digital
                        </h1>

                        <p style={{
                            fontSize: "1.1rem",
                            lineHeight: "1.8",
                            color: "#555"
                        }}>
                            Na <span style={{ fontWeight: "700", color: "#111" }}>ContBlack</span> você encontra
                            <span style={{ fontWeight: "700", color: "#111" }}> suporte especializado</span>,
                            <span style={{ fontWeight: "700", color: "#111" }}> atendimento humanizado</span>
                            e uma estrutura preparada para
                            <span style={{ fontWeight: "700", color: "#111" }}> creators que vivem da internet</span>.
                        </p>

                        <div style={{
                            marginTop: "35px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "18px"
                        }}>
                            {[
                                "Atendimento 100% Online em Todo o Brasil",
                                "Organização Simplificada",
                                "Suporte Especializado Para Creators",
                                "Mais Segurança, Tranquilidade e Previsibilidade",
                            ].map((item, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px"
                                    }}
                                >
                                    <div style={{
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "50%",
                                        background: "#000"
                                    }} />

                                    <span style={{
                                        fontSize: "1rem"
                                    }}>
                                        {item}
                                    </span>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>

            <div style={{
                marginTop: "120px",
                marginBottom: "60px",
                width: "100%",
                padding: "20px"
            }}>
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    style={{
                        width: "90%",
                        maxWidth: "1200px",
                        margin: "0 auto",
                        border: "1px solid #9C01B9",
                        background: "#f5f5f5",
                        borderRadius: "40px",
                        padding: "50px 40px",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <div style={{
                        position: "absolute",
                        top: "-80px",
                        right: "-80px",
                        width: "220px",
                        height: "220px",
                        borderRadius: "50%",
                        background: "#9C01B98A"
                    }} />

                    <div style={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: "700px"
                    }}>
                        <span style={{
                            fontWeight: "600",
                            color: "#9C01B9"
                        }}>
                            DIFERENCIAIS DIGITAIS
                        </span>

                        <h1 style={{
                            fontSize: "clamp(2rem, 4vw, 3.5rem)",
                            marginTop: "15px",
                            marginBottom: "20px"
                        }}>
                            Contabilidade feita para quem vive no digital
                        </h1>

                        <p style={{
                            fontSize: "1.1rem",
                            lineHeight: "1.8",
                            color: "#555"
                        }}>
                            Somos a <span style={{ fontWeight: "700", color: "#9C01B9" }}>Pioneira</span>.
                            Entendemos a rotina de
                            <span style={{ fontWeight: "700", color: "#111" }}> creators</span>,
                            <span style={{ fontWeight: "700", color: "#111" }}> influenciadores</span>,
                            <span style={{ fontWeight: "700", color: "#111" }}> afiliados</span> e
                            <span style={{ fontWeight: "700", color: "#111" }}> infoprodutores</span>.
                            Nossa estrutura foi criada para
                            <span style={{ fontWeight: "700", color: "#111" }}> simplificar processos</span>,
                            <span style={{ fontWeight: "700", color: "#111" }}> automatizar tarefas</span> e entregar uma experiência
                            <span style={{ fontWeight: "700", color: "#111" }}> moderna</span>,
                            <span style={{ fontWeight: "700", color: "#111" }}> prática</span> e
                            <span style={{ fontWeight: "700", color: "#111" }}> eficiente</span>.
                        </p>
                    </div>
                </motion.div>
            </div>
            <Plans sectionRef={sectionRef} />

            <WhatWeDo />

            <Avaliacoes />

            {listPlans.map((plan, index) => (
                <div key={index} style={{ width: "100%", padding: "20px", display: "flex", justifyContent: "center" }}>
                    <div style={{
                        marginBottom: "40px",
                        width: "100%",
                        maxWidth: "1200px",
                        display: "flex",
                        flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
                        alignItems: "center",
                        gap: "20px",
                        padding: "0 20px"
                    }}>
                        <div style={{ width: isMobile ? "100%" : "50%", padding: "0 10px" }}>
                            <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>{plan.title}</h1>
                            <p style={{ fontSize: "1rem", marginBottom: "10px" }}>{plan.subTitle}</p>
                            <p style={{ marginBottom: "10px", fontSize: "1.1rem" }}>{plan.description}</p>
                            <ul>
                                {plan.advantages.map((advantage, i) => (
                                    <li key={i}>{advantage}</li>
                                ))}
                            </ul>
                            <p style={{ fontWeight: "bold", marginTop: "10px" }}>{plan.finalText}</p>
                        </div>
                        <div style={{ width: isMobile ? "100%" : "50%" }}>
                            <img
                                src={plan.img}
                                alt={plan.title}
                                style={{ width: "100%", height: "auto", borderRadius: "44px 0 44px 0" }}
                            />
                        </div>
                    </div>
                </div>
            ))}

            <section style={{
                width: "100%",
                padding: "100px 20px",
                background: "linear-gradient(135deg, #233344, #15273a)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <div style={{
                    width: "100%",
                    maxWidth: "1200px",
                    background: "#ffffff",
                    borderRadius: "44px 0 44px 0",
                    padding: "70px 50px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.25)"
                }}>
                    <span style={{
                        background: "#f3f3f3",
                        color: "#111",
                        padding: "8px 18px",
                        borderRadius: "999px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        marginBottom: "25px"
                    }}>
                        Contabilidade especializada para creators
                    </span>

                    <h2 style={{
                        fontSize: "clamp(2.2rem, 5vw, 4rem)",
                        lineHeight: "1.1",
                        color: "#111",
                        maxWidth: "850px",
                        marginBottom: "25px",
                        fontWeight: "800"
                    }}>
                        Foque no seu conteúdo.
                        <br />
                        <span style={{ color: "#25D366" }}>
                            A contabilidade deixa com a gente.
                        </span>
                    </h2>

                    <p style={{
                        fontSize: "1.1rem",
                        lineHeight: "1.8",
                        color: "#555",
                        maxWidth: "760px",
                        marginBottom: "40px"
                    }}>
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            Abra sua empresa
                        </span>, organize seus {" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            impostos
                        </span> e tenha {" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            suporte especializado{" "}
                        </span>
                        para{" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            creators
                        </span>,{" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            influenciadores
                        </span>,{" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            afiliados{" "}
                        </span> e{" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            infoprodutores
                        </span>. Tudo de forma
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            {" "}simples
                        </span>,{" "}
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            digital{" "}
                        </span> e {" "}"sem
                        <span style={{ fontWeight: "700", color: "#111" }}>
                            burocracia"
                        </span>.
                    </p>

                    <Button variant="contained"
                        onClick={() => { setOpenModalHome(true); sessionStorage.setItem("modal-contblack", "true") }}
                        sx={{
                            backgroundColor: "#9C01B9",
                            borderRadius: "17px 0 17px 0",
                            padding: "12px 30px",
                            fontSize: "0.9rem",
                            color: "white",
                            fontWeight: 800,
                            border: "none",
                            transition: "0.3s ease",
                            '&:hover': {
                                backgroundColor: "#1EFF86",
                                boxShadow: "0 4px 10px #1EFF86",
                            }
                        }}>
                        Falar com um especialista
                    </Button>
                </div>
            </section>

            <Footer />
            {/* {!openModalHome ? (
                <WhatsAppButton />
            ) : null} */}
            <ModalHome
                openModalHome={openModalHome}
                setOpenModalHome={setOpenModalHome}
            />
        </>
    );
};

export default Planos;
